import api from './api.service';
import { OwnerGuarantorScheme } from '../types/candidat';

class OwnerGuarantorSchemeService {
  async list(): Promise<OwnerGuarantorScheme[]> {
    const response = await api.get('/owner-guarantor-schemes');
    return response.data;
  }

  async create(schemeCode: string, schemeLabel: string): Promise<OwnerGuarantorScheme> {
    const response = await api.post('/owner-guarantor-schemes', {
      scheme_code: schemeCode,
      scheme_label: schemeLabel,
      is_active: true,
    });
    return response.data;
  }

  async update(
    id: string,
    data: { scheme_label?: string; is_active?: boolean },
  ): Promise<OwnerGuarantorScheme> {
    const response = await api.patch(`/owner-guarantor-schemes/${id}`, data);
    return response.data;
  }

  async delete(id: string): Promise<void> {
    await api.delete(`/owner-guarantor-schemes/${id}`);
  }
}

export const ownerGuarantorSchemeService = new OwnerGuarantorSchemeService();
